import { usePlanningSocket } from '../../hooks/sockets/usePlanningSocket.js';

const PlanningSocketRunner = () => {
  usePlanningSocket();

  return null;
};

export default PlanningSocketRunner;
